import { z } from 'zod';

import { buildQueryString } from '../../utils/querystring';
import { LanguageCode } from '../brand/brand';
import { makeEndpoint } from '../common';
import { TranslationSchema } from '../translation';

export const GetTranslationsForVibesQuerySchema = z.object({
  vibeId: z.string().uuid().optional(),
  language: z.nativeEnum(LanguageCode).optional(),
});

export const GetTranslationsForVibesEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, query }: { brandId: string; query: z.input<typeof GetTranslationsForVibesQuerySchema> }) =>
    `/v1/brands/${brandId}/vibes/i18n?${buildQueryString(query)}`,
  responseSchema: z.object({
    translations: z.array(TranslationSchema),
  }),
  requestSchema: z.void(),
  querySchema: GetTranslationsForVibesQuerySchema,
});
